import { useRouter } from 'next/router'
import React, { useContext } from 'react'
import styled from 'styled-components'

import { ShippingText } from '@Components/Shipping/ShippingInfoModal/ShippingText'
import { MetadataContext } from '@Globals/Metadata'
import { formatMoney } from '@Globals/Money'
import { useTranslation } from '@Globals/Translations'

const IntroWrapper = styled.div`
  margin-bottom: 25px;
`

export const ShippingIntro = () => {
  const { t, tDanger } = useTranslation()
  const { store } = useContext(MetadataContext)
  const { locale = '' } = useRouter()

  const freeShippingThreshold = store?.config?.freeShippingThreshold || false

  return (
    <IntroWrapper>
      {freeShippingThreshold && (
        <ShippingText
          {...tDanger(
            'header:DELIVERY_INFO_INTRO_TEXT_WITH_THRESHOLD',
            { arg1: formatMoney(store?.id, locale, freeShippingThreshold) },
          )}
        />
      )}
      {!freeShippingThreshold && (
        <ShippingText>{t('header:DELIVERY_INFO_INTRO_TEXT')}</ShippingText>
      )}
    </IntroWrapper>
  )
}
